import { Serializer } from 'src/app/core/common/http/serializer';
import { AreaEnermanResource, AssignmentResource, ProfileResource } from './area-enerman.resource';
import { AreaEnermanModel } from '../model/area-enerman.model';

export class AreaEnermanSerializer implements Serializer { 

fromJson(json: any): AreaEnermanResource { 
    const resource = new AreaEnermanResource();
    resource.profile_enabled = new AssignmentResource();
    resource.profile_enabled.profile = new ProfileResource();
    resource.profile_enabled.profile.id = json.profile_enabled.profile.id;
    resource.profile_enabled.profile.description = json.profile_enabled.profile.description;
    resource.profile_enabled.enabled_disabled = json.profile_enabled.enabled_disabled;
    resource.cdc_associated = json.cdc_associated;
    resource.notes = json.notes;

    return resource;
  }

  toJson(model: AreaEnermanModel): any  {
    const resource = new AreaEnermanResource();
    resource.profile_enabled = new AssignmentResource();
    resource.profile_enabled.profile = new ProfileResource();
    resource.profile_enabled.profile.id = model.profile_enabled[0].id;
    resource.profile_enabled.enabled_disabled = model.enable_disabled;
    resource.cdc_associated = model.cdc_associated;
    resource.cdc_associated = resource.cdc_associated.filter((el:any) => el.value);
    resource.notes = model.notes;

    return resource;
  }
}
